import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import { NotificationIcon } from '@g99-product-web-ui/shared-util-lib';

@Component({
  selector: 'g99-lib-notification-button',
  templateUrl: './notification-button.component.html',
  styleUrls: ['./notification-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class NotificationButtonComponent {
  // Inputs (attributes first in template; see HTML below)
  @Input() public hasUnread = false;
  @Input() public ariaLabel = 'Notifications';
  @Input() public size = 36;
  @Input() public iconSize = 20;

  // Outputs
  @Output() public pressed = new EventEmitter<void>();

  // Fields
  protected notificationIcon = NotificationIcon;

  public onClick(): void {
    this.pressed.emit();
  }

  // Accessors as methods (explicit)
  public get btnStyle(): Record<string, string> {
    const px = `${this.size}px`;
    return { width: px, height: px };
  }

  public get iconStyle(): Record<string, string> {
    const px = `${this.iconSize}px`;
    return { width: px, height: px };
  }
}
